import * as React from 'react'
import useHasMounted from 'hooks/useHasMounted'

export const AppMountedContext = React.createContext(false)

export function AppMountedContextProvider({ children }: React.PropsWithChildren) {
  const isMounted = useHasMounted()

  return <AppMountedContext value={isMounted}>
    {children}
  </AppMountedContext>
}
